import React from "react";
import { connect } from "react-redux";
import ResultsList from "./component";
import Loader from "../../../../components/Loader";
import {
  fetchAllResults,
  deleteAdminResult,
} from "../../../../modules/results/actions";

import {
  printPDFOwnTa,
  printPDFEvuAdmin,
  printPDFAdminReport
} from "../../../../modules/pdf/actions";

class ResultsListContainer extends React.Component {
  componentWillMount() {
    this.props.fetchAllResults();
  }

  render() {
    
    let holder;
    let evaluations = [];

    //Adding correct drivers to correct evaluations in order to show drivers when printing PDF
    this.props.results.forEach(x => {
      holder = this.props.data.filter(y =>
        x.driver ? Object.values(x.driver).includes(y.id) : false
      );

      evaluations.push({ ...x, driver: holder });
    });

    //Setting type in order to filter the evaluations
    const type = this.props.selected;
    
    const { loading } = this.props;
    if (loading) {
      return <Loader />;
    }

    return (
      <div>
        <ResultsList
          {...this.props}
          type={type}
          deleteAdminResult={this.props.deleteAdminResult}
          chartData={this.props.data}
          results={evaluations
            .filter(x => x.type === type)
            .sort(function compare(a, b) {
              var dateA = new Date(a.createTime);
              var dateB = new Date(b.createTime);

              return dateB - dateA;
            })

            .sort(function compare(a, b) {
              var dateA = new Date(a.createTime);
              var dateB = new Date(b.createTime);

              return dateB - dateA;
            })}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    results: state.results.resultsMap,
    answers: state.results.adminResult.answers,
    data: state.results.dataMap,
    language: state.preference.language,
    loading: state.results.loading
  };
}

const mapActionsToProps = {
  fetchAllResults,
  deleteAdminResult,
  printPDFOwnTa,
  printPDFEvuAdmin,
  printPDFAdminReport
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(ResultsListContainer);



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultCollection/ResultsList/container.js